import React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { ShieldCheck } from 'lucide-react';
import { LicenseCard } from '../../components/LicenseCard';
import type { ILicenseConfigurationSectionProps } from '../interfaces';

export const LicenseConfigurationSection: React.FC<ILicenseConfigurationSectionProps> = ({
  catalog,
  isLicenseActive,
  onToggleLicense,
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  monthlyCredits,
  onMonthlyCreditsChange,
}) => (
  <Paper variant="outlined" sx={{ p: { xs: 2.5, md: 4 }, borderRadius: 4 }}>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 4 }}>
      <ShieldCheck size={22} color="#10b981" />
      <Typography variant="h6" sx={{ fontWeight: 800, color: 'text.primary', letterSpacing: '-0.01em' }}>
        License Configuration
      </Typography>
    </Box>

    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: {
          xs: '1fr',
          md: 'repeat(2, 1fr)',
          lg: 'repeat(3, 1fr)',
        },
        gap: 3,
      }}
    >
      {catalog.map((item) => (
        <LicenseCard
          key={item.id}
          title={item.label}
          iconPath={item.iconPath}
          iconClassName={item.iconClassName}
          isSpecialIcon={item.isSpecialIcon}
          active={isLicenseActive(item.licenseKey)}
          onToggle={() => onToggleLicense(item.licenseKey)}
          startDate={startDate(item.licenseKey)}
          endDate={endDate(item.licenseKey)}
          onStartDateChange={(value) => onStartDateChange(item.licenseKey, value)}
          onEndDateChange={(value) => onEndDateChange(item.licenseKey, value)}
          creditUnit={item.creditUnit}
          monthlyCredits={monthlyCredits(item.licenseKey)}
          onMonthlyCreditsChange={(value) => onMonthlyCreditsChange(item.licenseKey, value)}
        />
      ))}
    </Box>
  </Paper>
);
